import React, { FC } from "react"
import { ChipField, Datagrid, DateField, List, ReferenceField, TextField } from "react-admin"

import { SearchFilter } from "./utils"

export const ActivityEventsList: FC<any> = (props) => (
  <List
    {...props}
    filters={<SearchFilter {...props} />}
    sort={{ field: "createdAt", order: "DESC" }}
  >
    <Datagrid rowClick="edit">
      <ReferenceField reference="User" source="user">
        <ChipField source="username" />
      </ReferenceField>
      <TextField source="communityId" />
      <TextField source="type" />
      <TextField source="eventId" />
      <TextField source="properties" />
      <DateField showTime source="createdAt" />
    </Datagrid>
  </List>
)
